import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "grid grid-cols-8 bg-blue-sense px-4 lg:grid-cols-16 lg:px-0" }
const _hoisted_3 = { class: "col-span-8 lg:col-start-4" }
const _hoisted_4 = { class: "h2 pb-2 pt-19 text-blue-corporate lg:pb-12 lg:pt-32" }
const _hoisted_5 = { class: "grid grid-cols-8 bg-white px-4 lg:grid-cols-16 lg:px-0" }
const _hoisted_6 = { class: "col-span-7 pb-4 pt-4 lg:col-start-4 lg:pb-8" }
const _hoisted_7 = { class: "grid grid-cols-8 bg-white px-4 lg:grid-cols-16 lg:px-0" }
const _hoisted_8 = { class: "col-span-7 py-10 lg:col-start-4 lg:py-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DKRichText = _resolveComponent("DKRichText")!
  const _component_DKButton = _resolveComponent("DKButton")!

  return (_ctx.legalPage && _ctx.legalPageId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.legalPage.title), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_DKRichText, {
              text: _ctx.legalPage.body
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_DKButton, {
              type: "secondary",
              onClick: _ctx.onGoBack
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('go_back.button.label')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}